import moment from "moment";
import store from "../store";

export default {
  meetingDate(date) {
    const min = moment(new Date()).startOf('day').add(-30, 'days');
    const max = moment(new Date()).startOf('day');

    return date >= min && date <= max;
  },
  birthDate(date) {
    const min = moment(new Date()).startOf('day').add(-120, 'years');
    const max = moment(new Date()).startOf('day').add(-18, 'years');
    
    return date > min && date < max;
  },
  birthDateWarning(date) {
    const min = moment(new Date()).startOf('day').add(-120, 'years');
    const max = moment(new Date()).startOf('day').add(-18, 'years');

    return moment(date, 'DD/MM/YYYY') >= min && moment(date, 'DD/MM/YYYY') <= max;
  },
  moveDate(date) {
    // console.log('moveDateRule', date)
    const min = moment(new Date()).startOf('day').add(-55, 'days');
    const max = moment(new Date()).startOf('day').add(25, 'days');
  
    return date >= min && date <= max;
  },
  deliveryDate(date) {
    const min = moment().startOf('day').add(25, 'days');
    const max = moment().startOf('day').add(1,'years');

    return date >= min && date <= max;
  },
}


// WEBPACK FOOTER //
// ./src/validations/dateRules.js